import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { MediaCell } from '../../overviews/list-view/components/cells/media-cell/media-cell.entity';
import { TextCell } from '../../overviews/list-view/components/cells/text-cell/text-cell.entity';
import { ColumnDef } from '../../overviews/list-view/entities/column-definition.entity';
import { ColumnWidth } from '../../overviews/list-view/entities/column-width.entity';
import { sessionStorageHelper } from '../../session-storage/helpers/fetch-from-session-storage/session-storage.helper';
import { FragmentItem } from '../entities/fragment-item.entity';

export type FragmentColumn = ColumnDef<typeof FragmentColumnService, FragmentItem>;

@Injectable({ providedIn: 'root' })
export class FragmentColumnService {
    static MEDIA: FragmentColumn;
    static CURRENT_ITEM: FragmentColumn;

    constructor(private readonly translateService: TranslateService) {
        FragmentColumnService.MEDIA = new ColumnDef({
            key: 'MEDIA',
            translateLabel: `fragments-tab.item`,
            mapper: (fragmentItem: FragmentItem) =>
                new MediaCell({
                    title: fragmentItem.fragment.getTitle(),
                    imgSrc: fragmentItem.fragment.getThumbnailUrl(),
                    navigationLink: {
                        route: sessionStorageHelper.has('shareId')
                            ? fragmentItem.fragment.getShareDetailUrl(sessionStorageHelper.get('shareId')!)
                            : fragmentItem.fragment.getDetailUrl()
                    }
                }),
            width: ColumnWidth.WIDE
        });

        FragmentColumnService.CURRENT_ITEM = new ColumnDef({
            key: 'CURRENT_ITEM',
            translateLabel: `fragments-tab.current-item`,
            mapper: (fragmentItem: FragmentItem) =>
                new TextCell(
                    fragmentItem.isCurrent ? this.translateService.instant(`fragments-tab.list.current-item`) : ''
                ),
            width: ColumnWidth.NORMAL,
            headerHidden: true
        });
    }
}
